import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import chatApiService from '../services/api';

const DEFAULT_WS_URL = 'wss://7pumfc2f80.execute-api.eu-west-1.amazonaws.com/dev';
const DEFAULT_AUTH_TOKEN = 'q2Sw3xDZaGZd';

export const ChatApiContext = createContext<{
  isConnected: boolean;
  isConnecting: boolean;
  connect: () => void;
  disconnect: () => void;
}>({
  isConnected: false,
  isConnecting: false,
  connect: () => {},
  disconnect: () => {},
});

export const ChatApiProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [isConnecting, setIsConnecting] = useState<boolean>(false);

  useEffect(() => {
    console.log('ChatApiProvider: Setting up connection listener');

    const currentlyConnected = chatApiService.isConnected();
    setIsConnected(currentlyConnected);

    const unsubscribe = chatApiService.onConnectionChange((connected) => {
      console.log('ChatApiProvider: Connection status changed:', connected);
      setIsConnected(connected);
      if (connected) {
        setIsConnecting(false);
      }
    });

    return () => {
      console.log('ChatApiProvider: Cleaning up connection listener');
      unsubscribe();
    };
  }, []);

  const connect = () => {
    console.log('ChatApiProvider: Connecting with default URL and token');
    setIsConnecting(true);

    // Add a 1-second delay before attempting connection
    setTimeout(() => {
      chatApiService.connect(DEFAULT_WS_URL, DEFAULT_AUTH_TOKEN);

      // If connection is still not established after 10 seconds, set isConnecting to false
      setTimeout(() => {
        if (!chatApiService.isConnected()) {
          setIsConnecting(false);
        }
      }, 10000);
    }, 1000);
  };

  const disconnect = () => {
    console.log('ChatApiProvider: Disconnecting');
    setIsConnecting(false);
    chatApiService.disconnect();
  };

  return (
    <ChatApiContext.Provider value={{
      isConnected,
      isConnecting,
      connect,
      disconnect
    }}>
      {children}
    </ChatApiContext.Provider>
  );
};

export const useChatApi = () => {
  return useContext(ChatApiContext);
};